/** Word-level accuracy helpers for the STT lab. */

export function tokenize(text) {
  return String(text || '')
    .toLowerCase()
    .replace(/[''`´]/g, '')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);
}

export function wordErrorRate(expected, actual) {
  const ref = tokenize(expected);
  const hyp = tokenize(actual);
  if (!ref.length && !hyp.length) {
    return { wer: 0, accuracy: 100, substitutions: 0, insertions: 0, deletions: 0, refWords: 0, hypWords: 0 };
  }
  if (!ref.length) {
    return { wer: 1, accuracy: 0, substitutions: 0, insertions: hyp.length, deletions: 0, refWords: 0, hypWords: hyp.length };
  }
  const rows = ref.length + 1;
  const cols = hyp.length + 1;
  const dist = Array.from({ length: rows }, () => new Array(cols).fill(0));
  const ops = Array.from({ length: rows }, () => new Array(cols).fill(''));
  for (let i = 0; i <= ref.length; i += 1) {
    dist[i][0] = i;
    ops[i][0] = 'd';
  }
  for (let j = 0; j <= hyp.length; j += 1) {
    dist[0][j] = j;
    ops[0][j] = 'i';
  }
  ops[0][0] = '';
  for (let i = 1; i <= ref.length; i += 1) {
    for (let j = 1; j <= hyp.length; j += 1) {
      if (ref[i - 1] === hyp[j - 1]) {
        dist[i][j] = dist[i - 1][j - 1];
        ops[i][j] = 'e';
      } else {
        const sub = dist[i - 1][j - 1] + 1;
        const del = dist[i - 1][j] + 1;
        const ins = dist[i][j - 1] + 1;
        const best = Math.min(sub, del, ins);
        dist[i][j] = best;
        ops[i][j] = best === sub ? 's' : best === del ? 'd' : 'i';
      }
    }
  }
  let i = ref.length;
  let j = hyp.length;
  let substitutions = 0;
  let insertions = 0;
  let deletions = 0;
  while (i > 0 || j > 0) {
    const op = ops[i][j];
    if (op === 'e') {
      i -= 1;
      j -= 1;
    } else if (op === 's') {
      substitutions += 1;
      i -= 1;
      j -= 1;
    } else if (op === 'd') {
      deletions += 1;
      i -= 1;
    } else {
      insertions += 1;
      j -= 1;
    }
  }
  const wer = dist[ref.length][hyp.length] / ref.length;
  return {
    wer,
    accuracy: Math.max(0, Math.round((1 - wer) * 1000) / 10),
    substitutions,
    insertions,
    deletions,
    refWords: ref.length,
    hypWords: hyp.length,
  };
}
